/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "BE376E4C-F913-4149-BD0A-9EAEF3C91630",
  "sitecoreApiHost": "",
  "jssAppName": "cnhicorporate",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/cnhicorporate",
  "graphQLEndpoint": "/api/cnhicorporate?sc_apikey=BE376E4C-F913-4149-BD0A-9EAEF3C91630"
};